import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExpenseEditLayer from "../components/ExpenseEditLayer";





const ExpenseEditPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

    <ExpenseEditLayer />

      </MasterLayout>

    </>
  );
};

export default ExpenseEditPage;
